import React, { useEffect } from "react";
import styled from "@emotion/styled";

import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import LoginBox from "../../components/LoginBox/LoginBox";
import Header from "../../components/Header/Header";

function LoginBase(props) {
  const { config } = useSelector((state) => state.global);

  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = useSelector((state) => state.user);

  useEffect(() => {
    const isUserDataEmpty = !userData || Object.keys(userData).length === 0;

    if (!isUserDataEmpty) {
      navigate("/");
    }
  }, [userData, navigate]);

  return (
    <StyledContainer>
      <Header />
      <LoginBox navigate={navigate} location={location} {...config} />
    </StyledContainer>
  );
}

export default LoginBase;

const StyledContainer = styled.div`
  background-color: #ffffff;
  min-height: 100vh;
`;
